/* eslint-disable @typescript-eslint/naming-convention */

export enum CommandIdentifierEnum {
  // Default
  GO_TO_PORT_APP = "GO_TO_PORT_APP",
  GO_TO_NOTE_APP = "GO_TO_NOTE_APP",
  GO_TO_SMART_SEARCH_APP = "GO_TO_SMART_SEARCH_APP",
  GO_TO_CHARTERER_APP = "GO_TO_CHARTERER_APP",

  // Note
  CREATE_NOTE = "CREATE_NOTE",

  // Port
  CREATE_PORT_LINEUP = "CREATE_PORT_LINEUP",
  CREATE_SEA_PASSAGE = "CREATE_SEA_PASSAGE",

  // CHARETERER
  ADD_DIRECTORY_COMPANY = "ADD_DIRECTORY_COMPANY",
  CREATE_CONTRACT = "CREATE_CONTRACT",
  CREATE_SPOT_CONTRACT = "CREATE_SPOT_CONTRACT",

  // BUSINESS DIRECTORY
  ADD_BUSINESS_COMPANY = "ADD_BUSINESS_COMPANY",
}
